import { createSelector } from "reselect";
import { State } from "state/modules";
import { ComplexFilterType } from "interfaces/filters";
import { CHANNEL_NAMES } from "interfaces/channels";

import { ReservationsState } from "./types";

export const getReservationsState = (state: State): ReservationsState =>
	state.reservations;

export const getReservationsList = createSelector(
	getReservationsState,
	(state) => {
		const { reservations, reservationsFilter } = state;

		const statusFilter = reservationsFilter.find(
			(f) => f.type === ComplexFilterType.STATUS
		);
		const channelFilter = reservationsFilter.find(
			(f) => f.type === ComplexFilterType.CHANNEL
		);
		const searchFilter = reservationsFilter.find(
			(f) => f.type === ComplexFilterType.SEARCH
		);

		const statusValue = statusFilter?.value as string | null;
		const channelValue = channelFilter?.value as CHANNEL_NAMES | null;
		const searchValue = (searchFilter?.value as string | null)?.toLowerCase();

		return reservations.filter((item) => {
			if (statusValue) {
				if ((item._item.status || "").toLowerCase() !== statusValue.toLowerCase()) {
					return false;
				}
			}

			if (channelValue) {
				const itemChannel = item._item.channel;
				if (itemChannel !== channelValue && !(channelValue === CHANNEL_NAMES.AIRBNB && itemChannel === CHANNEL_NAMES.AIRBNB_OFFICIAL)) {
					return false;
				}
			}

			if (searchValue) {
				const guest = item._item.guest;
				const code = item._item.code || "";
				const propertyName = item.property?.name || "";
				const searchable = `${guest?.first_name ?? ''} ${guest?.last_name ?? ''} ${code} ${propertyName}`.toLowerCase();
				if (!searchable.includes(searchValue)) {
					return false;
				}
			}

			return true;
		});
	}
);

export const getReservationsLoading = createSelector(
	getReservationsState,
	(state) => state.isLoading
);

export const getReservationsFilter = createSelector(
	getReservationsState,
	(state) => state.reservationsFilter
);

export const getReservationsCalendarDateRange = createSelector(
	getReservationsState,
	(state) => state.reservationsCalendarRange
);

export const getReservationsCalendarItems = createSelector(
	getReservationsState,
	(state) => state.reservationsCalendarItems
);

export const getReservationsReport = createSelector(
	getReservationsState,
	(state) => state.report
);
